import React, { Component } from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import { colors } from "./../constants"

class AppPreview extends Component {
  render() {
    var { name, appId, description, imageUrl } = this.props.data
    return (
      <div>
        <a href={`/app/${appId}`} style={{ textDecoration: "none", color: "#333c48" }}>
          <div
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: "cover",
              paddingBottom: "50%"
            }}
          />
          <h4 style={{ margin: "10px 0" }}>{name}</h4>
          <p style={{ fontSize: 13, lineHeight: "18px", margin: 0 }}>{description}</p>
        </a>
      </div>
    )
  }
}

export default AppPreview



// WEBPACK FOOTER //
// ./src/lib/AppPreview.js